export default "__VITE_ASSET__Cm$Egvag__"